import React from 'react';
import PropTypes from 'prop-types';

export const IconProducerChecked = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="20"
    viewBox="0 0 22 20"
    fill="none"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M19.8295 6.29772C20.4153 5.71193 20.4153 4.76219 19.8295 4.1764C19.2437 3.59061 18.2939 3.59061 17.7082 4.1764L9.18103 12.7035L4.64883 8.17101C4.06307 7.58521 3.11332 7.58517 2.52751 8.17094C1.9417 8.75671 1.94167 9.70645 2.52744 10.2923L8.11982 15.885C8.52386 16.2891 9.10109 16.4145 9.61259 16.2611C9.84317 16.1923 10.0604 16.0668 10.2425 15.8847L19.8295 6.29772Z" fill="url(#check-gradient)" />
  </svg>
);

IconProducerChecked.propTypes = {
  className: PropTypes.string
};

IconProducerChecked.defaultProps = {
  className: ''
};

